import {
  SET_GUESTS
} from 'app/actions/types';

import {
  getGuests as getGuestsSvc
} from 'app/services/guests';

export const getGuests = params => async dispatch => {
  let guests = await getGuestsSvc(params);

  if (guests) {
    dispatch({
      type: SET_GUESTS,
      payload: guests.params
    });
  }

  return guests;
}

export const setGuestParams = params => async dispatch => {
  dispatch({
    type: SET_GUESTS,
    payload: params
  });
}

